import { BaseWebComponent } from "../base-components/base-web-component.js";
import { LoginComponent } from "./login-component.js";
import { authStore } from "./AuthStore.js";
import { LoginBase } from "./login-base.js";

export class LoginForm extends LoginBase {
    static webComponentName: string = 'login-form';
    protected _templateId: string = 'login-form';
    private get passwordEl(): HTMLInputElement | null {
        return this.querySelector('input[name="password"]');
    }
    private get emailEl(): HTMLInputElement | null {
        return this.querySelector('input[name="email"]');
    }
    private get btnLoginSubmit(): HTMLButtonElement | null {
        return this.roleElementSelector("handle-login-submit") as HTMLButtonElement | null;
    }
    private get handleLoginForm(): HTMLFormElement | null {
        return this.roleElementSelector("handleLogin") as HTMLFormElement | null;
    }
    public get email(): string {
        return this.parentComponent.email;
    }
    public set email(value: string) {
        this.parentComponent.email = value;
    }
    private _password: string = '';
    public get password(): string {
        return this._password;
        this.handleBtnSubmitState();
    }
    public set password(value: string) {
        this._password = value;
        this.handleBtnSubmitState();
    }
    private _recoveryMode: boolean = false;
    public get recoveryMode(): boolean {
        return this._recoveryMode;
    }
    public set recoveryMode(value: boolean) {
        const changed = (this._recoveryMode != value);
        this._recoveryMode = value;
        if (changed) this.render();
    }
    loginError: string = '';
    private _isLoading: boolean = false;
    public get isLoading(): boolean {
        return this._isLoading;
    }
    public set isLoading(value: boolean) {
        this._isLoading = value;
        this.handleLoading();
    }
    protected onConnected(): void {
        this.on('click', `[role="handle-toggle-recovery"]`, (e:Event) => {
            e.preventDefault();
            this.recoveryMode = !this.recoveryMode;
            this.parentComponent.isPasswordRecovery = this.recoveryMode;
        });
        super.onConnected();
    }
    private get parentComponent(): LoginComponent | null {
        return this.closest('login-component');
    }
    clearError(event: Event) {
        const target = event.target;
        (target as HTMLInputElement).classList.remove('is-invalid');
    }
    handleLoading() {
        this.emailEl?.toggleAttribute("disabled", this.isLoading);
        this.passwordEl?.toggleAttribute("disabled", this.isLoading);
        this.handleBtnSubmitState();
        Array.from(this.querySelectorAll('.loading')).forEach(el => el.classList.toggle('d-none', !this.isLoading));
        Array.from(this.querySelectorAll('.not-loading')).forEach(el => el.classList.toggle('d-none', this.isLoading));
    }
    handleBtnSubmitState() {
        this.btnLoginSubmit?.toggleAttribute("disabled", this.isLoading || !this.email || !this.password || !this.emailEl?.checkValidity());
    }
    async handleLogin(event: Event) {
        event.preventDefault();
        const form = event.target as HTMLFormElement;

        // Reset stati
        this.loginError = "";
        this.isLoading = true;

        try {
            const loginResult = await authStore.login(this.email, this.password);
            if (loginResult.success) {
                this.dispatch('loginSuccess', loginResult);
            } else {
                this.loginError = loginResult.error || 'Credenziali non valide';
            }
        } catch (error) {
            this.loginError = 'Errore durante il login. Riprova.';
        } finally {
            this.isLoading = false;
        }
    };
    protected afterRender(): void {
        this.handleLoginForm?.addEventListener('submit', this.handleLogin.bind(this));
        if (this.passwordEl) {
            this.bindElementValue(this.passwordEl, 'password');
        }
        if (this.emailEl) {
            this.bindElementValue(this.emailEl, 'email');
        }
        this.handleBtnSubmitState();
        super.afterRender();
    }

    protected buildRenderingData(): Record<string, any> {
        return {
            recoveryMode: this.recoveryMode,
            loginError: this.loginError,
            email: this.email,
        }
    }
}